import E from "../../@babel/runtime/helpers/esm/inheritsLoose.js";
import h from "../../@babel/runtime/helpers/esm/defineProperty.js";
import l, { PureComponent as y } from "react";
function N(u, a) {
  if (process.env.NODE_ENV !== "production") {
    if (typeof u != "function") throw new Error("Expected reducePropsToState to be a function.");
    if (typeof a != "function") throw new Error("Expected handleStateChangeOnClient to be a function.");
  }
  function m(i) {
    return i.displayName || i.name || "Component";
  }
  return function (c) {
    if (process.env.NODE_ENV !== "production" && typeof c != "function") throw new Error("Expected WrappedComponent to be a React component.");
    var t = [],
      f;
    function p() {
      f = u(t.map(function (n) {
        return n.props;
      })), a(f);
    }
    var d = /* @__PURE__ */function (n) {
      E(e, n);
      function e() {
        return n.apply(this, arguments) || this;
      }
      e.peek = function () {
        return f;
      };
      var o = e.prototype;
      return o.componentDidMount = function () {
        t.push(this), p();
      }, o.componentDidUpdate = function () {
        p();
      }, o.componentWillUnmount = function () {
        var s = t.indexOf(this);
        t.splice(s, 1), p();
      }, o.render = function () {
        return /* @__PURE__ */l.createElement(c, this.props);
      }, e;
    }(y);
    return h(d, "displayName", "SideEffect(" + m(c) + ")"), d;
  };
}
export { N as default };